import React, { useState, useEffect, ChangeEvent, useRef } from "react";
import "./component.css";
import {
  ADD_DOC_FILE,
  GET_ALL_ACCESSIBLE_DOCS,
  PATCH_ACCOUNT_INFO,
  PATCH_USER_INFO,
} from "../utils/constants";
import {
  makeAuthenticatedGet,
  makeAuthenticatedPatch,
  makeAuthenticatedPostForFile,
} from "../utils/fetchUtils";
import { useNavigate } from "react-router-dom";
import { Bounce, ToastContainer, toast } from "react-toastify";
import { DocData } from "../utils/types";
import uploadImg from "../assets/upload-img.svg";
import or from "../assets/or.svg";
import downArrow from "../assets/down-arrow.svg";
import useWindowWidth from "../utils/windowWidth";

// Define the type for form data
type FormDataType = {
  employmentStatus: string;
  jobSearchStatus: string;
  disability: string;
  preferredIndustry: string;
  preferredRole: string;
};

const EditAccountForm = (props:any) => {
  const navigate = useNavigate();

  const inputRef = useRef<HTMLInputElement>(null);

  // react states
  const [formData, setFormData] = useState<FormDataType>({
    employmentStatus: "",
    jobSearchStatus: "",
    disability: "",
    preferredIndustry: "",
    preferredRole: ""
  });
  const [isDirty, setIsDirty] = useState(false);

  // const handleOptionChange = (event: any) => {
  //   setSelectedOption(event.target.value);
  //   handleChange(event);
  // };

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement |  HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log(formData);
    // Process form data
    const formDataToSubmit = new FormData();
    formDataToSubmit.append("employmentStatus", formData.employmentStatus);
    formDataToSubmit.append("jobSearchStatus", formData.jobSearchStatus);
    formDataToSubmit.append("disability", formData.disability);
    formDataToSubmit.append("preferredIndustry", formData.preferredIndustry);
    formDataToSubmit.append("preferredRole", formData.preferredRole);

    // Example: Sending data to an API
    console.log("Form Data:", formDataToSubmit);

    makeAuthenticatedPatch(PATCH_ACCOUNT_INFO, formDataToSubmit)
      .then((response) => {
        console.log(response);
        navigate('/profile');
      })
      .catch((error) => console.log(error));
  };

  //use Effects

  useEffect(() => {}, [formData]);

  useEffect(() => {}, []);

  useEffect(() => {
      if (props.accountDetails) {
        setFormData({
          ...formData,
          employmentStatus: props.accountDetails?.employmentStatus,
          jobSearchStatus: props.accountDetails?.jobSearchStatus,
          disability: props.accountDetails?.disability,
          preferredIndustry: props.accountDetails?.preferredIndustry,
          preferredRole: props.accountDetails?.preferredRole
        });
      }
    }, [props]);

   //window size
   const windowWidth = useWindowWidth();
   const isMobile = windowWidth < 769;

  return (
    <>
      <form
        className="doc-form profile-form"
        onSubmit={handleSubmit}
        aria-live="polite"
        id="myForm"
      >
        <div className="input-container" style={{ width: isMobile? "90%":'46%' }}>
          <div className="mb-3 input-div input-div-10">
            <h2 id="output-format" className="form-label">
              Employment Status
            </h2>
            {/* <input
              style={{ marginTop: "1rem" }}
              className="form-control input-5"
              id="output-format"
              name="employmentStatus"
              aria-label="Employment Status"
              value={formData.employmentStatus}
              aria-labelledby="Employment Status"
              placeholder="Employment Status"
              onChange={handleChange}
            ></input> */}
            <select
              style={{ marginTop: "1rem" }}
              className="form-control input-5"
              id="output-format"
              name="employmentStatus"
              aria-label="Employment Status"
              value={formData.employmentStatus}
              onChange={handleChange}
              aria-labelledby="Employment Status"
            >
              <option value="" disabled hidden>
              Employment Status
              </option>
              <option value="Employed-private sector">Employed-private sector</option>
              <option value="Employed-public sector">Employed-public sector</option>
              <option value="Unemployed">Unemployed</option>
              <option value="Student">Student</option>
              <option value="Retired">Retired</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
        <div className="input-container" style={{ width: isMobile? "90%":'46%' }}>
          <div className="mb-3 input-div input-div-10">
            <h2 id="output-format" className="form-label">
              Job Search Status
            </h2>
            {/* <input
              style={{ marginTop: "1rem" }}
              className="form-control input-5"
              id="output-format"
              name="jobSearchStatus"
              aria-label="Job Search Status"
              value={formData.jobSearchStatus}
              aria-labelledby="Job Search Status"
              placeholder="Job Search Status"
              onChange={handleChange}
            ></input> */}
            <select
              style={{ marginTop: "1rem" }}
              className="form-control input-5"
              id=""
              name="jobSearchStatus"
              aria-label="Job Search Status"
              value={formData.jobSearchStatus}
              onChange={handleChange}
              aria-labelledby="Job Search Status"
            >
              <option value="" disabled hidden>
              Job Search Status
              </option>
              <option value="Actively Looking">Actively looking for job</option>
              <option value="Open to Opportunities">Open to Opportunities</option>
              <option value="Not Looking">Not Looking</option>
              <option value="Considering a Career Change">Considering a Career Change</option>
              <option value="Available for Freelance/Contract">Available for Freelance/Contract</option>
              <option value="Looking for Internship">Looking for Internship</option>
            </select>
          </div>
        </div>
        <div className="input-container" style={{ width: isMobile? "90%":'46%' }}>
          <div className="mb-3 input-div input-div-10">
            <h2 id="output-format" className="form-label">
              Disability
            </h2>
            <input
              style={{ marginTop: "1rem" }}
              className="form-control input-5"
              id="output-format"
              name="disability"
              aria-label="Disability"
              value={formData.disability}
              aria-labelledby="Disability"
              placeholder="Disability"
              onChange={handleChange}
            ></input>
          </div>
        </div>
        <div className="input-container" style={{ width: isMobile? "90%":'46%' }}>
          <div className="mb-3 input-div input-div-10">
            <h2 id="output-format" className="form-label">
              Preferred Industry
            </h2>
            <input
              style={{ marginTop: "1rem" }}
              className="form-control input-5"
              id="output-format"
              name="preferredIndustry"
              aria-label="Preferred Industry"
              value={formData.preferredIndustry}
              aria-labelledby="Preferred Industry"
              placeholder="Preferred Industry"
              onChange={handleChange}
            ></input>
          </div>
        </div>
        <div className="input-container" style={{ width: isMobile? "90%":'46%' }}>
          <div className="mb-3 input-div input-div-10">
            <h2 id="output-format" className="form-label">
              Preferred Role
            </h2>
            <input
              style={{ marginTop: "1rem" }}
              className="form-control input-5"
              id="output-format"
              name="preferredRole"
              aria-label="Preferred Role"
              onChange={handleChange}
              aria-labelledby="Preferred Role"
              placeholder="Preferred Role"
              value={formData.preferredRole}
            ></input>
          </div>
        </div>
      </form>
      <div
        style={{ width: "100%", paddingTop: "2rem" }}
        className="d-flex items-center justify-center"
      >
        <button
          type="submit"
          className="doc-submit"
          disabled={isDirty}
          form="myForm"
        >
          Update
        </button>
      </div>
    </>
  );
};

export default EditAccountForm;
